Services.Hash = function Hash() {
    return Math.random().toString(36).slice(2);
};
